import { combine, withCallback, withContext } from 'react-hooks-combine'
import { ServicesContext } from 'services/context'
import { withTableController } from 'shared/hooks'
import { StoreContext } from 'store/context'

import DeleteButtonComponent from './component'

export const Delete = combine(
  withTableController({ id: 'teams-table' }),
  withContext('appStore', StoreContext),
  withContext(
    'adminTeamsService',
    ServicesContext,
    ({ adminTeamsService }) => adminTeamsService
  ),
  withCallback(
    'onDeleteTeamById',
    ({ adminTeamsService, table }, { value }) =>
      () => {
        adminTeamsService.removeTeamById(value.id).then(() => table.refresh())
      },
    ['value']
  )
)(DeleteButtonComponent)
